import { Roles } from '@dataquiver/stoneage-roles';
import { JobLog } from 'src/models/jobLog';
import { AuthUserInfo } from 'src/redux/auth/types';

/**
 * Determines if the user can update a log
 *
 * @param user - the user updating the log
 * @param log - the job log being updated
 *
 * @returns true if the user can update the log
 */
export const canUpdateJobLog = (user: AuthUserInfo | undefined, log: JobLog | undefined) => {
  if (!user || !log) return false;

  if (log.status !== 'complete') return false;

  if (Roles.isUser(user.role, { isExact: true })) return false;

  if (Roles.isStoneAgeDev(user.role)) return true;

  return Roles.isManager(user.role) && user.org === log.org;
};

/**
 * Determines if the user can delete a log
 *
 * @param user - the user updating the log
 * @param log - the job log being updated
 *
 * @returns true if the user can delete the log
 */
export const canDeleteJobLog = (user: AuthUserInfo | undefined, log: JobLog | undefined) => {
  if (!user || !log) return false;

  if (log.status !== 'complete') return false;

  if (Roles.isStoneAgeDev(user.role)) return true;

  return Roles.isManager(user.role) && user.org === log.org;
};
